import { ComponentAPI } from '@philips-internal/oswald-ui-core';
export default class CardExamsLabDetailsListItemAPI extends ComponentAPI {
}
//# sourceMappingURL=card-exams-lab-details-list-item-api.js.map